import { OrderDetail } from 'components/order/order-detail/OrderDetail'
import { useSearchParams } from 'react-router-dom'
import { useFetch } from 'services/useFetch'
import { API_ORDER } from 'services/apiOrder'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'

export const OrderDetailContainer = () => {
    const [searchParams] = useSearchParams()
    const orderId = searchParams.get('orderId')
    const [selectedValue, setSelectedValue] = useState({})
    const {
        data: orderDetail,
        fetching: getOrderDetailApi,
        isLoading: isLoadingDetail,
    } = useFetch(
        {
            ...API_ORDER.DETAIL,
            initPathVariable: orderId,
        },
        {},
        { isFetching: true },
    )
    const { data: shippingDetail, isLoading: isLoadingShipping } = useFetch(
        {
            ...API_ORDER.TRACKING_AWB,
            initPathVariable: orderId,
        },
        {},
        { isFetching: true },
    )
    const { data: orderLog, isLoading: isLoadingOrderLog } = useFetch(
        {
            ...API_ORDER.LOG,
            initPathVariable: orderId,
        },
        {},
        { isFetching: true },
    )
    const { fetching: updateStatusApi } = useFetch({ ...API_ORDER.CHANGE_STATUS, initPathVariable: orderId })

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])

    const onChangeState = () => {
        updateStatusApi({ status: selectedValue?.value }).then(() => {
            getOrderDetailApi()
            return Alert({
                icon: 'success',
                title: 'Berhasil',
                message: 'Status Order Changed !',
            })
        })
    }

    const props = {
        data: orderDetail?.data,
        selectedValue,
        onSelectValue: setSelectedValue,
        onChangeState,
        shippingDetail: shippingDetail?.data,
        orderLog: orderLog?.data,
        isLoading: isLoadingDetail || isLoadingShipping || isLoadingOrderLog,
    }

    return <OrderDetail {...props} />
}
